<template>
  <el-dialog
    :title="$t('common.delete')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog">
    <div class="text-center">
      <p>{{ $t('serviceImplManage.confirmDeleteServiceImpl') }}</p>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="deleteServiceImpl">{{ $t('common.confirmDelete') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { deleteServiceImpl } from '@/api/dev/serviceImplApi'

export default {
  name: 'DeleteServiceImpl',
  data() {
    return {
      dialogVisible: false,
      deleteServiceImplInfo: {}
    }
  },
  methods: {
    open(serviceImpl) {
      this.deleteServiceImplInfo = { ...serviceImpl }
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
      this.deleteServiceImplInfo = {}
    },
    deleteServiceImpl() {
      deleteServiceImpl(this.deleteServiceImplInfo).then(() => {
        this.$message.success(this.$t('common.submitSuccess'))
        this.$emit('success')
        this.closeDialog()
      }).catch(err => {
        console.error(err)
      })
    }
  }
}
</script>